module.exports = __webpack_public_path__ + "img/prop-tv-3-left.beb84b57.png";